import { Injectable } from '@angular/core';

import {
    ClientConfigProductName,
    LazyClientConfig,
    LazyClientConfigBase,
    LazyClientConfigService,
    MenuContentItem,
    ViewTemplateForClient,
} from '@frontend/vanilla/core';

import { InvitationUrl, ReferredFriends } from './referred-friends.models';

/**
 * @stable
 *
 * @description Provides configuration for the referred friends feature.
 *
 * @see {@link https://admin.dynacon.prod.env.works/services/263833/features/484624 DynaCon config}
 */
@LazyClientConfig({ key: 'vnReferredFriends', product: ClientConfigProductName.SF })
@Injectable({
    providedIn: 'root',
    deps: [LazyClientConfigService],
    useFactory: referredFriendsConfigFactory,
})
export class ReferredFriendsConfig extends LazyClientConfigBase {
    content: { [key: string]: ViewTemplateForClient };
    detailsButton: MenuContentItem;
    trackReferralsButton: MenuContentItem;
    shareContent: MenuContentItem;
    referredFriends: ReferredFriends;
    invitationUrl: InvitationUrl;
}

export function referredFriendsConfigFactory(service: LazyClientConfigService): ReferredFriendsConfig {
    return service.get(ReferredFriendsConfig);
}
